<template>
  <div id="orderConfirmed">
    <div xclass="header">
      <div class="van-hairline--bottom background_color_d6f1ec van-nav-bar font_weight_bold" style="z-index: 1;">
        <div class="van-ellipsis van-nav-bar__title">{{ $t("order.confirmed") }}</div>
      </div>
    </div>

    <div class="content2" v-show="orderHeader.OrderId">
      <div class="order-title">Thank you for the order</div>
      <van-divider />
      <van-row class="order-header">
        <van-col class="" span="24">Order Number : {{ orderHeader.OrderId }}</van-col>
      </van-row>
      <van-row class="order-item" v-for="(item, index) in orderItems" :key="index">
        <van-col span="1"></van-col>
        <van-col class="qty" span="3">{{ item.OrderQty }}</van-col>
        <van-col class="title1" span="12"> {{ item.Title }} </van-col>
        <van-col class="price" span="6">{{ item.Extension | currency }}</van-col>
      </van-row>
      <div class="order-total">
        <van-row class="subtotal">
          <van-col class="title1" span="16">Subtotal</van-col>
          <van-col class="amount" span="6">{{ orderHeader.Subtotal | currency }}</van-col>
        </van-row>
        <van-row class="freight">
          <van-col class="title1" span="16">Freight</van-col>
          <van-col class="amount" span="6">{{ orderHeader.Freight | currency }}</van-col>
        </van-row>
        <van-row class="taxes">
          <van-col class="title1" span="16">Taxes</van-col>
          <van-col class="amount" span="6">{{ taxes | currency }}</van-col>
        </van-row>
        <van-row class="total">
          <van-col class="title1" span="16">Total</van-col>
          <van-col class="amount" span="6">{{ orderHeader.Total | currency }}</van-col>
        </van-row>
      </div>
    </div>
    <div class="pa-4">{{ errorMsg }}</div>
    <van-divider />
    <van-row v-show="$vuetify.breakpoint.smAndDown">
      <van-col span="24" align="center">
        <v-btn outlined @click="$router.push({ name: 'home' })"> Continue shopping </v-btn>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  computed: {
    member() {
      return this.$store.state.member;
    },
    taxes() {
      return this.orderHeader.GSTax + this.orderHeader.PSTax;
    },
  },
  data() {
    return {
      errorMsg: "",
      orderHeader: {},
      orderItems: {},
    };
  },

  mounted() {
    // check is it a call back?
    let plen = Object.keys(this.$route.query).length;
    if (plen > 0) {
      let memId = 0;
      if ("MemberId" in this.member) {
        memId = this.member.MemberId;
      }
      this.$ajax2log({ from: "ocfm-cb", mem: memId, query: this.$route.query });
      if ("ptype" in this.$route.query) {
        let obj = JSON.parse(localStorage.getItem("orderObj"));
        // localStorage.removeItem('orderObj');
        if (this.$route.query.ptype == "ALI") {
          obj.data.billto = {
            billType: "ALIPAY",
            orderId: this.$route.query.orderID,
            tranId: this.$route.query.tranID,
            status: this.$route.query.status,
            query: this.$route.query,
          };
          this.postOrder(obj, true);
        } else if (this.$route.query.ptype == "WECHAT") {
          obj.data.billto = {
            billType: "WECHATPAY",
            orderId: this.$route.query.orderId,
            tranId: this.$route.query.tranID,
            status: this.$route.query.status,
            query: this.$route.query,
          };
          this.postOrder(obj, true);
        }
      }
    } else {
      this.loadStates();
    }
  },

  beforeDestroy() {},

  methods: {
    // ------------------------------------------------------------------------ loadStates
    loadStates() {
      if (this.$store.state.orderConfirmed) {
        if ("data" in this.$store.state.orderConfirmed) {
          this.orderHeader = this.$store.state.orderConfirmed.data;
          if ("Products" in this.orderHeader) {
            this.orderItems = this.orderHeader.Products;
          }
        } else {
          this.errorMsg = "There is no order information available.";
          // this.$router.push({ name: "home" });
        }
      } else {
        this.errorMsg = "There is no order information available.";
      }
    },
    // ------------------------------------------------------------------------ postOrder
    postOrder(obj, toHome = false) {
      this.$ajax2
        .post("NewOrder", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.$store.commit("cartCount", 0);
            this.orderHeader = rpdata.data.data;
            if ("Products" in this.orderHeader) {
              this.orderItems = this.orderHeader.Products;
            }
            // this.$router.push({ name: "home" });
          } else if (rpdata.data.meta.msg != "") {
            this.errorMsg = "Failed to place order. " + rpdata.data.meta.msg;
          }
        })
        .catch((err) => {
          this.errorMsg = "Failed to place order. " + rpdata.data.meta.msg;
        });
    },
  },
};
</script>

<style>
.order-title {
  padding-top: 10px;
  text-align: center;
  font-size: 1.5em;
}
.order-header {
  text-align: center;
}
.order-item {
  margin-top: 10px;
  padding: 10px;
}
.order-item .price {
  text-align: right;
}
.order-total {
  padding: 10px;
}
.order-total .van-row {
  margin-top: 10px;
}
.order-total .title1 {
  text-align: right;
}
.order-total .amount {
  text-align: right;
}
.order-total .total .amount {
  font-weight: bold;
}

.content1 {
  padding: 0px;
  --margin: 0px !important;
}
</style>
